export const visaTypeImage = 'https://tokyojob-public.s3.ap-northeast-1.amazonaws.com/public/visa-type.png'
export const visaSubTypeImage = 'https://tokyojob-public.s3.ap-northeast-1.amazonaws.com/public/visa-sub-type.png'

